module.exports = __webpack_public_path__ + "static/media/camposLogo.142c4ee6.webp";